const PORTAL_COLORS = {
  "ShipKorea.in": "bg-blue-50 text-blue-700 border-blue-200",
  "ShipJapan.in": "bg-rose-50 text-rose-700 border-rose-200",
  "ShipUAE.in": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "ShipOMS Direct": "bg-slate-100 text-slate-600 border-slate-200",
};

export default function PortalBadge({ portal, testId }) {
  const cls = PORTAL_COLORS[portal] || "bg-orange-50 text-orange-700 border-orange-200";
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1 rounded-md border px-2 py-0.5 text-[11px] font-semibold whitespace-nowrap ${cls}`}
    >
      {portal || "—"}
    </span>
  );
}

export function Route({ from, to }) {
  if (!to || to === "Domestic") return null;
  return (
    <span className="text-[11px] text-muted-foreground whitespace-nowrap">
      {from || "India"} → {to}
    </span>
  );
}
